<div class="modal-content">
  <div class="modal-header bg-info">
    <h5 class="modal-title white">{{ title }}</h5>
    <button
      *ngIf="exibirBtnFecharHeader"
      (click)="onCancel()"
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-scroll">
    <div class="row">
      <div class="col-md-12 text-center">
        <p>{{ message }}</p>

        <ng-content></ng-content>
        <!-- Renderiza o conteúdo projetado -->
      </div>
    </div>
  </div>
  <div *ngIf="exibirBtnFechar" class="modal-footer d-flex modal-fixed-footer">
    <app-geia-button
      type="info"
      label="Fechar"
      icon="fa fa-times"
      data-dismiss="modal"
      extraClass="round float-right"
      (click)="onCancel()"></app-geia-button>
  </div>
</div>
